export default __webpack_public_path__ + "static/media/plus-icon.49063b7c.svg";